import { Radio, Typography } from "@mui/material";
import React, { useState } from "react";
import { FooterButton } from "../../ServiceFunctionsModal.styles";
import { ReportReason } from "../../../../../Infrastructure/Services/ReportService.types";
import {
    ContentTypography,
    ReasonListItem,
    ReasonListItemButtonBase,
    ReportingReasonsContainer,
} from "../ServiceModal.styles";
import { ReasonListItemText } from "./ReportingConfirmationModal.styles";
import { CommunityCircularProgress } from "../../../../Shared/styles";

let selectedId: number | undefined = undefined;

export default function ReportingConfirmation({
    reportReasons,
    isLoading,
    showReportOptionsErrorLabel,
    onReportConfirmation,
}: any) {
    const modalTitle = <Typography>Wie können wir helfen?</Typography>;
    const modalContent = (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: isLoading ? "hidden" : "auto",
                    alignItems: !isLoading ? "start" : "center",
                }}
            >
                <Typography sx={{ padding: "0 16px 8px 16px" }}>
                    Teile uns mit, was zu beanstanden ist. Deine Meldung wird
                    dann umgehend von unserem Team geprüft.
                </Typography>
                {!isLoading && (
                    <ReportingReasonsList reportReasons={reportReasons} />
                )}
                {isLoading && (
                    <div style={{ marginTop: "4px" }}>
                        <CommunityCircularProgress />
                    </div>
                )}
            </div>
            {showReportOptionsErrorLabel && (
                <ContentTypography color={"red"}>
                    Bitte wählen Sie einen Grund!
                </ContentTypography>
            )}
        </>
    );
    const modalActions = (
        <FooterButton
            variant={"text"}
            onClick={() => {
                selectedId && onReportConfirmation(selectedId);
            }}
            disabled={isLoading}
        >
            Missbrauch melden
        </FooterButton>
    );
    return { modalTitle, modalContent, modalActions };
}

function ReportingReasonsList({
    reportReasons,
}: {
    reportReasons: ReportReason[];
}) {
    const [selectedContentReportOption, setSelectedContentReportOption] =
        useState<number | undefined>();

    function onRadioButtonClick(value: number) {
        const newValue =
            value === selectedContentReportOption ? undefined : value;
        setSelectedContentReportOption(newValue);
        selectedId = newValue;
    }

    return (
        <ReportingReasonsContainer>
            {reportReasons.map((reason: ReportReason, key: number) => {
                return (
                    <ReasonListItemButtonBase key={key}>
                        <ReasonListItem
                            component="label"
                            secondaryAction={
                                <Radio
                                    checked={
                                        selectedContentReportOption ===
                                        reason.id
                                    }
                                    onClick={() =>
                                        onRadioButtonClick(reason.id)
                                    }
                                    name="radio-buttons"
                                    sx={{
                                        color: "var(--community-color-dark-gray)",
                                    }}
                                />
                            }
                            disablePadding
                        >
                            <ReasonListItemText>
                                {reason.name}
                            </ReasonListItemText>
                        </ReasonListItem>
                    </ReasonListItemButtonBase>
                );
            })}
        </ReportingReasonsContainer>
    );
}
